import { Close, Search, SearchOutlined } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, SxProps, TextField, Theme } from '@mui/material';
import React, { useState } from 'react'
export interface SearchBarProps<T> {
    onSearchChange: (searchQuery: string, items: T[]) => void;
    items: T[];
    propsToSearch: (keyof T)[];
    sxWrap?: SxProps<Theme>;
    variant?: 'standard' | 'filled' | 'outlined';
    fullWidth?: boolean;
    size?: 'small' | 'medium';
    placeholder?: string;
    minimized?: boolean;
    label?: string;
}

export default function SearchBox<T>(props: Readonly<SearchBarProps<T>>) {

    const { onSearchChange, items, propsToSearch, sxWrap, fullWidth, placeholder, size, variant, minimized, label } = props;
    const [searchQuery, setSearchQuery] = useState('');
    const [openedInMinimizedMode, setOpenedInMinimizedMode] = useState(false);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setSearchQuery(e.target.value);
        let filtered = items.filter((item) => {
            return propsToSearch.some((prop) => {
                let value = item[prop];
                let valueStr = typeof value === 'string' ? value : String(value);
                return valueStr.toLowerCase().includes(e.target.value.toLowerCase());
            });
        });
        onSearchChange(e.target.value, filtered);
    }
    if (minimized) {
        return <Box sx={sxWrap}>{openedInMinimizedMode && <TextField
            size={size}
            fullWidth={fullWidth}
            variant={variant}
            type="text"
            label={label}
            placeholder={placeholder}
            value={searchQuery}
            onChange={handleChange}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => { setOpenedInMinimizedMode(false); onSearchChange('', items); setSearchQuery(''); }}
                                edge="end"
                            >
                                <Close />
                            </IconButton>
                        </InputAdornment>
                    ),
                }
            }}

            id="searchInput" />
        }
            {!openedInMinimizedMode && <IconButton onClick={(e) => { setOpenedInMinimizedMode(true) }}><SearchOutlined /></IconButton>}
        </Box>
    }
    else
        return (
            <Box sx={sxWrap}>
                <TextField
                    size={size}
                    fullWidth={fullWidth}
                    variant={variant}
                    type="text"
                    label={label}
                    placeholder={placeholder}
                    value={searchQuery}
                    onChange={handleChange}
                    slotProps={{
                        input: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <Search />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }
                    }}

                    id="searchInput" />
                {/* </SkeletonConditional> */}
            </Box>
        );
}
